import {
  CategoryState,
  EventAction,
  EventState,
  initialCategoryState,
} from '../reducer/EventsReducer';
import React, { useContext } from 'react';

type EventContext = {
  state: EventState;
  dispatch: React.Dispatch<EventAction>;
};

export const EventContext = React.createContext<EventContext | null>(null);

export const useEventContext: () => [
  EventState,
  React.Dispatch<EventAction>,
] = () => {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('Context not found' + EventContext);
  }
  return [context.state, context.dispatch];
};

export const useEventByCategory = (categoryId: string): CategoryState => {
  const [state] = useEventContext();
  if (state.initial) {
    return initialCategoryState;
  }
  return state.data[categoryId] ?? initialCategoryState;
};
